"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _CalendarSt = require("./Calendar.st.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BaseCalendar = _interopRequireDefault(require("./BaseCalendar/BaseCalendar"));

var _addMonths = _interopRequireDefault(require("date-fns/addMonths"));

var _subMonths = _interopRequireDefault(require("date-fns/subMonths"));

var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));

var _isSameDay = _interopRequireDefault(require("date-fns/isSameDay"));

var _utils = require("./utils");

var _LocaleUtils = _interopRequireDefault(require("../common/LocaleUtils/LocaleUtils"));

var _DatePickerHead = _interopRequireDefault(require("./DatePickerHead"));

var _context = require("../WixStyleReactEnvironmentProvider/context");

var _wixDesignSystemsLocaleUtils = require("wix-design-systems-locale-utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Calendar = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Calendar, _React$PureComponent);

  var _super = _createSuper(Calendar);

  function Calendar(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Calendar);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setMonth", function (month) {
      _this.setState({
        month: month
      });

      var onMonthChange = _this.props.onMonthChange;

      if (onMonthChange) {
        onMonthChange(month);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getLocaleUtilsFactory", function (locale, firstDayOfWeek) {
      return (0, _LocaleUtils["default"])(locale, firstDayOfWeek);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_createCaptionElement", function () {
      var _this$props = _this.props,
          showMonthDropdown = _this$props.showMonthDropdown,
          showYearDropdown = _this$props.showYearDropdown,
          leftArrowAriaLabel = _this$props.leftArrowAriaLabel,
          leftArrowAriaLabelledBy = _this$props.leftArrowAriaLabelledBy,
          rightArrowAriaLabel = _this$props.rightArrowAriaLabel,
          rightArrowAriaLabelledBy = _this$props.rightArrowAriaLabelledBy,
          monthDropdownAriaLabel = _this$props.monthDropdownAriaLabel,
          monthDropdownAriaLabelledBy = _this$props.monthDropdownAriaLabelledBy,
          yearDropdownAriaLabel = _this$props.yearDropdownAriaLabel,
          yearDropdownAriaLabelledBy = _this$props.yearDropdownAriaLabelledBy;
      var month = _this.state.month;

      var locale = _this._getLocale();

      var localeUtils = _this._getLocaleUtilsFactory(locale);

      return /*#__PURE__*/_react["default"].createElement(_DatePickerHead["default"], {
        className: _CalendarSt.classes.header,
        date: month,
        showYearDropdown: showYearDropdown,
        showMonthDropdown: showMonthDropdown,
        locale: typeof locale === 'string' ? locale : '',
        localeUtils: localeUtils,
        onChange: _this._setMonth,
        onLeftArrowClick: function onLeftArrowClick() {
          return _this._setMonth((0, _startOfMonth["default"])((0, _addMonths["default"])(month, -1)));
        },
        onRightArrowClick: function onRightArrowClick() {
          return _this._setMonth((0, _startOfMonth["default"])((0, _addMonths["default"])(month, 1)));
        },
        leftArrowAriaLabel: leftArrowAriaLabel,
        leftArrowAriaLabelledBy: leftArrowAriaLabelledBy,
        rightArrowAriaLabel: rightArrowAriaLabel,
        rightArrowAriaLabelledBy: rightArrowAriaLabelledBy,
        monthDropdownAriaLabel: monthDropdownAriaLabel,
        monthDropdownAriaLabelledBy: monthDropdownAriaLabelledBy,
        yearDropdownAriaLabel: yearDropdownAriaLabel,
        yearDropdownAriaLabelledBy: yearDropdownAriaLabelledBy
      });
    });
    var initialMonth = Calendar.getUpdatedMonth(props.value, props.numOfMonths);
    _this.state = {
      month: initialMonth || new Date()
    };
    return _this;
  }

  (0, _createClass2["default"])(Calendar, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        var month = Calendar.getUpdatedMonth(nextProps.value, nextProps.numOfMonths, this.state.month);

        if (month) {
          this.setState({
            month: month
          });
        }
      }
    }
  }, {
    key: "_getLocale",
    value: function _getLocale() {
      return this.props.locale || this.context.locale || 'en';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          dataHook = _this$props2.dataHook,
          className = _this$props2.className,
          autoFocus = _this$props2.autoFocus,
          numOfMonths = _this$props2.numOfMonths,
          firstDayOfWeek = _this$props2.firstDayOfWeek,
          onChange = _this$props2.onChange,
          onClose = _this$props2.onClose,
          excludePastDates = _this$props2.excludePastDates,
          filterDate = _this$props2.filterDate,
          value = _this$props2.value,
          selectionMode = _this$props2.selectionMode,
          shouldCloseOnSelect = _this$props2.shouldCloseOnSelect,
          locale = _this$props2.locale,
          rtl = _this$props2.rtl,
          dateIndication = _this$props2.dateIndication,
          today = _this$props2.today;
      var month = this.state.month;
      return /*#__PURE__*/_react["default"].createElement(_BaseCalendar["default"], {
        dataHook: dataHook,
        className: (0, _CalendarSt.st)(_CalendarSt.classes.root, className),
        autoFocus: autoFocus,
        numOfMonths: numOfMonths,
        firstDayOfWeek: firstDayOfWeek,
        onChange: onChange,
        onClose: onClose,
        excludePastDates: excludePastDates,
        filterDate: filterDate,
        value: value,
        selectionMode: selectionMode,
        shouldCloseOnSelect: shouldCloseOnSelect,
        locale: locale,
        rtl: rtl,
        dateIndication: dateIndication,
        today: today,
        onDisplayedViewChange: this._setMonth,
        displayedMonth: month,
        captionElement: this._createCaptionElement()
      });
    }
  }], [{
    key: "areValuesEqual",
    value: function areValuesEqual() {
      var value1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var value2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!Boolean(value1) && !Boolean(value2)) {
        return true;
      }

      if (Calendar.isRangeValue(value1) && Calendar.isRangeValue(value2)) {
        return (0, _isSameDay["default"])(value1.from, value2.from) && (0, _isSameDay["default"])(value1.to, value2.to);
      }

      return (0, _isSameDay["default"])(value1, value2);
    }
  }, {
    key: "isSingleDay",
    value: function isSingleDay(value) {
      return value instanceof Date;
    }
  }, {
    key: "isRangeValue",
    value: function isRangeValue(value) {
      return Boolean(value.from || value.to);
    }
  }]);
  return Calendar;
}(_react["default"].PureComponent);

exports["default"] = Calendar;
(0, _defineProperty2["default"])(Calendar, "displayName", 'Calendar');
(0, _defineProperty2["default"])(Calendar, "defaultProps", {
  className: '',
  filterDate: function filterDate() {
    return true;
  },
  dateIndication: function dateIndication() {
    return null;
  },
  shouldCloseOnSelect: true,
  onClose: function onClose() {},
  autoFocus: true,
  excludePastDates: false,
  selectionMode: 'day',
  showMonthDropdown: false,
  showYearDropdown: false,
  numOfMonths: 1
});
(0, _defineProperty2["default"])(Calendar, "optionalParse", _BaseCalendar["default"].optionalParse);
(0, _defineProperty2["default"])(Calendar, "parseValue", _BaseCalendar["default"].parseValue);
(0, _defineProperty2["default"])(Calendar, "nextDay", _BaseCalendar["default"].nextDay);
(0, _defineProperty2["default"])(Calendar, "prevDay", _BaseCalendar["default"].prevDay);
(0, _defineProperty2["default"])(Calendar, "getUpdatedMonth", function (nextPropsValue, numOfMonths, currentMonthDate) {
  var nextValue = Calendar.parseValue(nextPropsValue);

  if (!currentMonthDate) {
    return Calendar.isSingleDay(nextValue) ? nextValue : nextValue.from || nextValue.to;
  }

  var view = new _utils.CalendarView(currentMonthDate, numOfMonths);

  if (Calendar.isSingleDay(nextValue)) {
    if (!view.isContained(nextValue)) {
      return nextValue;
    }
  } else {
    var from = nextValue.from,
        to = nextValue.to;

    if (from && view.isAfterView(from)) {
      //         F--- =>  F---
      //   VVVVV      =>  VVVVV
      return from;
    } else if (to && view.isBeforeView(to)) {
      if (view.isRangeFits(from, to)) {
        //   F-T        =>  F-T
        //       VVVVV  =>  VVVVV
        return from;
      } else {
        //   F-----T        =>  F-----T
        //          VVVVV    =>    VVVVV
        return (0, _subMonths["default"])(to, numOfMonths - 1);
      }
    } else if (from && view.isBeforeView(from) && to && view.isAfterView(to)) {
      //   F-------T  =>    F-------T
      //     VVVVV    =>    VVVVV
      return from; // choose the 'from' anchor arbitrarly
    }
  }
  /*
   * We only changed the month if the day (or range.edges) are outside the view.
   * This is to avoid changing the month right after a user clicks on the calendar.
   */


  return null;
});
Calendar.contextType = _context.WixStyleReactEnvironmentContext;
Calendar.propTypes = {
  /** Applies as data-hook HTML attribute that can be used in the tests */
  dataHook: _propTypes["default"].string,

  /** Focus selected day automatically when component mounts or updates */
  autoFocus: _propTypes["default"].bool,

  /** Allows to display multiple months at once. Currently it shows 1 or 2 months only. */
  numOfMonths: _propTypes["default"].oneOf([1, 2]),

  /** First day of the week, allowing only from 0 to 6 (Sunday to Saturday). The default value is 1 which means Monday. */
  firstDayOfWeek: _propTypes["default"].oneOf([0, 1, 2, 3, 4, 5, 6]),

  /** A single CSS class name to be appended to the root element. */
  className: _propTypes["default"].string,

  /** Provides a callback function when  day in selected in the calendar */
  onChange: _propTypes["default"].func.isRequired,

  /** Defines a callback function that is called with the date of the first day of the month whenever the user selects a month in the calendar */
  onMonthChange: _propTypes["default"].func,

  /** Defines a callback function that is  called whenever a user presses escape, clicks outside of the element or a date is selected and `shouldCloseOnSelect` is set. Receives an event as a first argument. */
  onClose: _propTypes["default"].func,

  /** Specify whether past dates should be selectable or not */
  excludePastDates: _propTypes["default"].bool,

  /**
   * ##### Specify selectable dates:
   *  * `param` {Date} `date` - a date to check
   *  * `return` {boolean} - true if `date` should be selectable, false otherwise
   */
  filterDate: _propTypes["default"].func,

  /** Defines the selected date */
  value: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].shape({
    from: _propTypes["default"].instanceOf(Date),
    to: _propTypes["default"].instanceOf(Date)
  })]),

  /** Whether the user should be able to select a date range, or just a single day */
  selectionMode: _propTypes["default"].oneOf(['day', 'range']),

  /** Displays a selectable yearDropdown */
  showYearDropdown: _propTypes["default"].bool,

  /** Displays a selectable monthDropdown */
  showMonthDropdown: _propTypes["default"].bool,

  /** Specify whether the calendar closes on day selection */
  shouldCloseOnSelect: _propTypes["default"].bool,

  /** Specify date picker instance locale */
  locale: _propTypes["default"].oneOf(_wixDesignSystemsLocaleUtils.supportedWixlocales),

  /** Specify whether RTL mode is enabled or not. When true, the keyboard navigation will be changed means pressing on the right arrow will navigate to the previous day, and pressing on the left arrow will navigate to the next day. */
  rtl: _propTypes["default"].bool,

  /**
   ##### Add an indication under a specific date.
   Function returns the indication node of a specific date or null if this day doesn't have an indication.
   * - `param` {date: Date, isSelected: boolean }
   * - `date` - a date
   * - `isSelected` - whether this date is the selected date
   * - `return` {React.node} - the indication node of a specific date or null if this day doesn't have an indication.
  */
  dateIndication: _propTypes["default"].func,

  /** Sets today's date. The today indication is added automatically according to the user timezone but in some cases, we need the ability to add the today indication based on the business timezone. */
  today: _propTypes["default"].instanceOf(Date),

  /** Defines a string value that labels the left arrow in calendar header */
  leftArrowAriaLabel: _propTypes["default"].string,

  /** Identifies the element that labels the left arrow in calendar header */
  leftArrowAriaLabelledBy: _propTypes["default"].string,

  /** Defines a string value that labels the right arrow in calendar header */
  rightArrowAriaLabel: _propTypes["default"].string,

  /** Identifies the element that labels the right arrow in calendar header */
  rightArrowAriaLabelledBy: _propTypes["default"].string,

  /** Defines a string value that labels the months dropdown in calendar header */
  monthDropdownAriaLabel: _propTypes["default"].string,

  /** Identifies the element that labels the months dropdown in calendar header */
  monthDropdownAriaLabelledBy: _propTypes["default"].string,

  /** Defines a string value that labels the years dropdown in calendar header */
  yearDropdownAriaLabel: _propTypes["default"].string,

  /** Identifies the element that labels the years dropdown in calendar header */
  yearDropdownAriaLabelledBy: _propTypes["default"].string
};